import { makeApiCall } from './api';
import {
  PodcastEpisodeModel,
  PodcastModel,
  RssContentModel,
  SongHistoryEntry,
  SongHistoryRequestPayload,
} from '../models';

export const getRssContent = async (
  urlBase64: string,
  currentPage: number,
  bearerToken: string,
  appId: number,
  order: 'desc' | 'asc' = 'desc',
): Promise<Readonly<RssContentModel>> => {
  const config = {
    Authorization: 'Bearer ' + bearerToken,
  };
  const res = await makeApiCall<RssContentModel>({
    url: `${process.env.REACT_APP_MOBILE_API_URL}/${appId}/rss/${urlBase64}?page=${currentPage}&order=${order}`,
    headers: config,
  });
  return res.data;
};

export const getPodcastListAndEpisodes = async (
  list: string[],
  bearerToken: string,
  appId: number,
): Promise<
  Readonly<{ podcasts: Partial<PodcastModel>[]; lastEpisodes: PodcastEpisodeModel[] }>
> => {
  const config = {
    Authorization: 'Bearer ' + bearerToken,
  };
  const res = await makeApiCall<{
    podcasts: Partial<PodcastModel>[];
    lastEpisodes: PodcastEpisodeModel[];
  }>({
    url: `${process.env.REACT_APP_MOBILE_API_URL}/${appId}/podcasts/info-from-list/web`,
    method: 'POST',
    data: { list },
    headers: config,
  });
  return res.data;
};

export const getPodcastUrlFromId = async (
  tab: string,
  podcastId: string,
): Promise<Readonly<string>> => {
  const res = await makeApiCall<string>({
    url: `${process.env.REACT_APP_MOBILE_API_URL}/${process.env.REACT_APP_APP_ID}/podcasts/deeplink/${tab}/${podcastId}`,
  });
  return res.data;
};

export const getPodcastEpisodeFromEpisodeId = async (
  tab: string,
  podcastId: string,
  episodeId: string,
): Promise<Readonly<PodcastEpisodeModel>> => {
  const res = await makeApiCall<PodcastEpisodeModel>({
    url: `${process.env.REACT_APP_MOBILE_API_URL}/${process.env.REACT_APP_APP_ID}/podcasts/deeplink/${tab}/${podcastId}/${episodeId}`,
  });
  return res.data;
};

export const fetchSongHistory = async (
  payload: SongHistoryRequestPayload,
  bearerToken: string,
  appId: number,
): Promise<Readonly<SongHistoryEntry[]>> => {
  const config = {
    Authorization: 'Bearer ' + bearerToken,
  };

  const args =
    'url=' +
    encodeURIComponent(payload.apiUrl) +
    (payload.date ? '&date=' + encodeURIComponent(payload.date) : '');

  const res = await makeApiCall<SongHistoryEntry[]>({
    url: `${process.env.REACT_APP_MOBILE_API_URL}/${appId}/ckoi/request/web?${args}`,
    headers: config,
  });
  return res.data;
};
